import { Header } from "@empreinte/components.header";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../Redux/hooks";
import Hooks from "../utils/hooks";
import AddIcon from "@mui/icons-material/Add";

const HeaderIp = () => {
  const { t } = useTranslation();
  const {
    handleAddAuthorizedIP,
    onResetAuthorizedIP,
    UpdateAuthorizedIP,
    values,
    AddAuthorizedIP,
  } = Hooks();
  const showDivCondition = useAppSelector(
    (state: any) => state.AuthorizedIPReducer.showDivsConditionsAuthorizedIP
  );
  const isSuperAdmin = useAppSelector((state: any) => state.ReducerUserData.isSuperAdmin)
  const { configuration_autorise_ip_module } = useAppSelector((state: any) => state.ReducerUserData.modules)
  const handleEditIp = () => {
    UpdateAuthorizedIP(values);
  };
  const handleAddIp = () => {
    AddAuthorizedIP(values);
  };
  const disablesubmitform = showDivCondition.disablesubmitform;
  return (
    <>
      <div>
        {!showDivCondition.addAuthorizedIP &&
          !showDivCondition.editAuthorizedIP && (
            <Header
              hasPermission={(configuration_autorise_ip_module?.boitier_autoriseip_post_add_action?.authorized || isSuperAdmin) ? "boitier_autoriseip_post_add_action" : ""}
              addPermission="boitier_autoriseip_post_add_action"
              title={
                <span className={"profile_title"}>
                  {t("boitier.authorizedIp")}
                </span>
              }
              firstBtnTitle={t("boitier.btnAdd")}
              mainPageBtnAction={handleAddAuthorizedIP}
              firstBtnIcon={<AddIcon />}
              onMainPage={true}
            />
          )}
      </div>
      <div>
        {showDivCondition.addAuthorizedIP && (
          <Header
            hasPermission={(configuration_autorise_ip_module?.boitier_autoriseip_post_add_action?.authorized || isSuperAdmin) ? "boitier_autoriseip_post_add_action" : ""}
            addPermission="boitier_autoriseip_post_add_action"
            title={
              <span className={"profile_title"}>
                {t("boitier.AuthorizedIP.Add")}
              </span>
            }
            secondBtnTitle={t("boitier.btnCancel")}
            thirdBtnTitle={t("boitier.btnValidate")}
            arrowBackAction={onResetAuthorizedIP}
            CancelBtnAction={onResetAuthorizedIP}
            addBtnAction={handleAddIp}
            onMainPage={false}
            isDisabled={disablesubmitform}
          />
        )}
      </div>
      <div>
        {showDivCondition.editAuthorizedIP && (
          <Header
            hasPermission="false"
            title={
              <span className={"profile_title"}>
                {" "}
                {t("boitier.AuthorizedIP.Edit")}
              </span>
            }
            onMainPage={false}
            secondBtnTitle={t("boitier.btnCancel")}
            thirdBtnTitle={t("boitier.btnValidate")}
            arrowBackAction={onResetAuthorizedIP}
            CancelBtnAction={onResetAuthorizedIP}
            addBtnAction={handleEditIp}
            isDisabled={disablesubmitform}
          />
        )}
      </div>
    </>
  );
};

// interface Props {
//   isDisabled: boolean;
// }
export default HeaderIp;
